export default "__VITE_ASSET__CvFWenYE__"